import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import { ChangePositionControlPanel } from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import { ChangePositionList } from './components/ChangePositionList/ChangePositionList';
import { AdditionalRestaurantsModal } from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import { BtnBlock } from './components/BtnBlock';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangePortionPositionContext,
	IChangePortionPositionContext,
} from '../changePortionPositionState/changePortionPositionContext';
import style from './ChangePortionPosition.module.scss';

export const ChangePortionPosition: React.FC = () => {
	const { positionsData, IDSelectedDish } = useContext<IChangePortionPositionContext>(ChangePortionPositionContext);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangePortionPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
					<AdditionalRestaurantsModal />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!IDSelectedDish} />
			)}
			<NoFiltersChangePosition isVisible={!IDSelectedDish} />
		</div>
	);
};
